export default __webpack_public_path__ + "static/media/IconDesc_SuperPositionOscillator.256.e139228d.png";